import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import FooterMedia from "./FooterMedia";

const ResponsiveFooter = () => {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1100px)");

    const handleResize = () => {
      setIsMobileView(mediaQuery.matches);
    };

    // Set initial value
    handleResize();

    // Add event listener
    mediaQuery.addListener(handleResize);

    // Cleanup the event listener on component unmount
    return () => mediaQuery.removeListener(handleResize);
  }, []);

  return isMobileView ? <FooterMedia /> : <Footer />;
};

export default ResponsiveFooter;
